import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import {
    Typography
} from '@mui/material';
import { Form, Button, Modal, ModalBody, ModalFooter, Chip } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';

import './styles.scss';

//actions
import {
    clearRedux,
    tagsOpenCloseDeleteTagsModal,
    tagsDeleteTags
} from 'Redux/actions';

const DeleteTags = (props) => {
    const dispatch = useDispatch();
    const { callback } = props;
    const { messages } = useIntl();

    const deleteTagsForm = useRef();

    const open = useSelector(state => state.deleteTagsRedux.open);
    const items = useSelector(state => state.deleteTagsRedux.selected);
    const response = useSelector(state => state.deleteTagsRedux.response);
    const loading = useSelector(state => state.deleteTagsRedux.loading);

    const [formData, setFormData] = useState({});
    const [errorMessage, setErrorMessage] = useState(null);

    let moveEntities = false;
    moveEntities = items?.find(item => item?.unitsCount || item?.companiesCount);

    useEffect(() => {
        return () => {
            dispatch(clearRedux("TAGS_DELETE_TAGS"));
            setFormData({});
        }
    }, []);

    useEffect(() => {
        if (response && open) {
            if (response.error) {
                NotificationManager.error(
                    messages['errorMessage'],
                    messages['error'],
                    3000,
                    null,
                    null,
                    'warning',
                );
            } else {
                NotificationManager.success(
                    messages['tagsDeleteTags_deleted'],
                    messages['success'],
                    3000,
                    null,
                    null,
                    'success',
                );
                callback && callback();
                handleClose();
            }
        }
    }, [response, open]);

    const onSubmit = useCallback(() => {
        setErrorMessage(null);

        dispatch(tagsDeleteTags({
            ids: items?.map(item => item?.id)
        }));
    });

    const handleClose = useCallback(() => {
        dispatch(tagsOpenCloseDeleteTagsModal(false));
        dispatch(clearRedux("TAGS_DELETE_TAGS"));
        setFormData({});
    });

    return (
        <Modal
            title={messages['tagsDeleteTags_title']}
            open={open}
            position="right"
            size="small"
            style={{ overflow: 'hidden' }}
            className="overflow-hidden"
            handleClose={handleClose}
        >
            <ModalBody
                style={{
                    overflow: 'hidden',
                    marginBottom: 0
                }}
            >
                <div
                    style={{
                        padding: 24,
                        height: "calc(100vh - 225px)",
                        overflowX: 'auto'
                    }}
                >
                    <Form ref={deleteTagsForm} onValidSubmit={onSubmit}>
                        <Typography
                            variant="subtitle2"
                            color="textSecondary"
                        >
                            {messages['tagsDeleteTags_deleteWarning']}
                        </Typography>

                        {
                            (items && items?.length) &&
                            <ul className='delete-tags-list'>
                                {
                                    items.map((item, key) => {
                                        return (
                                            <li key={key}>
                                                <Chip style={{ backgroundColor: item?.color ? `#${item.color}` : "#000000", color: "#FFFFFF" }} label={item.label || ''}></Chip>
                                            </li>
                                        )
                                    })
                                }
                            </ul>
                        }
                    </Form>
                </div>
            </ModalBody>

            <ModalFooter style={{ boxShadow: "2px 2px 2px 1px rgb(2 0 0 / 94%)" }}>
                <Button
                    disabled={loading}
                    onClick={handleClose}
                    className="btn-cancel"
                >
                    {messages['cancel']}
                </Button>

                <Button
                    disabled={loading}
                    onClick={(e) => {
                        if (e) e.preventDefault();
                        deleteTagsForm.current.submit();
                    }}
                    className="btn-red"
                >
                    {messages['delete']}
                </Button>
            </ModalFooter>
        </Modal>
    );
}

export default DeleteTags;